import React from "react";

export default function Reviews() {
  return <h1>Reviews goes here</h1>;
}
